const donations = [
  {
    id: "1",
    title: "Masjid Donation",
    authorTitle: "Masjid Donation",
    shortDes:
      "Donation for a masjid operational costs, rennovation, maintenance etc.",
    poster: "https://i.ibb.co/HhpQxPw/Masjid-Donation.jpg",
    isReceipt: false,
  },

  // {
  //   id: "2",
  //   title: "Zakat Al Fitr",
  //   authorTitle: "Zakat Al Fitr",
  //   shortDes:
  //     "Zakat Al Fitr (also referred to as Fitra or Fitrana) has been set at $15 per person in New Zealand- be it man, woman or child.",
  //   poster: "https://i.ibb.co/CWZFnX3/zakat-al-fitr.jpg",
  //   rate: 15,
  //   isReceipt: false,
  // },
  {
    id: "3",
    title: "Zakat Al Maal",
    authorTitle: "Zakat Al Maal",
    shortDes:
      "Give Zakat al Maal to help the orphans, widows and families in need. Help us reach the Needy, Widows & Orphans with your Zakat.",
    poster: "https://i.ibb.co/qY3psPF/Zakat-Al-Maal.jpg",
    isReceipt: false,
  },

  // {
  //   id: "3",
  //   title: "Qadr Fund",
  //   authorTitle: "Laylat-ul-Qadr (Itikaf Night Stay Program)",
  //   shortDes: "",
  //   poster: "/images/posters/qadr_donation.jpg",
  //   rate: 10,
  //   isReceipt: false,
  // },

  // {
  //   id: "5",
  //   title: "Our Masjid Iftar Program",
  //   authorTitle: "Iftar Donation",
  //   shortDes:
  //     "Masjid is organising Ramadan Iftar program in collaboration with other centres in North Shore. Please donate fo this cause.",
  //   poster: "/images/posters/iftar_fund.jpg",
  //   isReceipt: false,
  // },

  {
    id: "6",
    title: "Madrasha Donation",
    authorTitle: "Madrasah Classes & Children's Education",
    shortDes: "",
    poster: "https://i.ibb.co/rZ297WB/Madrasa-Classes.jpg",
    isReceipt: false,
  },
  // {
  //   id: "4",
  //   title: "Massey Iftar Donation",
  //   authorTitle: "Jummah Food Fund Raising",
  //   shortDes:
  //     "Masjid is organising Ramadan Iftar program in collaboration with other centres in North Shore. Please donate fo this cause.",
  //   poster: "/images/posters/food_fund.jpg",
  //   isReceipt: false,
  // },

  // {
  //   id: "7",
  //   title: "Biriyani Fund",
  //   authorTitle: "Food Fund Raising",
  //   shortDes:
  //     "Buy your dinner box and support the Fund raising for the Masjid.",
  //   poster:
  //     "https://i.ibb.co/BZ1Fyc7/Whats-App-Image-2023-10-05-at-11-18-25.jpg",
  //   rate: 35,
  //   isReceipt: true,
  // },
  // {
  //   id: "8",
  //   title: "Food Fund",
  //   authorTitle: "Janaza Van : Sadaqa e Jariya",
  //   shortDes: "",
  //   poster: "https://i.ibb.co.com/ksDpxmFt/sadaqa-e-jariya.jpg",
  // },
  {
    id: "9",
    title: "Dawah Donation",
    authorTitle: "Dawah",
    shortDes: "Donate to our Dawah Program",
    poster: "https://i.ibb.co/KqhqgM7/Dawah.jpg",
  },
  {
    id: "-1",
    title: "Touch Tap Go",
    authorTitle: "Touch Tap Go",
  },
];

export default donations;
